import React, {FC} from 'react';
import {IonTextarea} from '@ionic/react';

type UITextareaProps = {
  handleTextareaChange: Function;
  fillText: string;
}

const UITextarea: FC<UITextareaProps> = ({handleTextareaChange, fillText}) => {
  return (
    <IonTextarea
      className='border w-full rounded pl-4'
      value={fillText}
      onIonChange={(e) => handleTextareaChange(e)}
    ></IonTextarea>
  );
};

export default UITextarea;
